"use client"

import type React from "react"
import { Sidebar } from "@/components/sidebar"
import { BottomTabBar } from "@/components/bottom-tab-bar"
import { ThemeToggle } from "@/components/theme-toggle"
import { useMobile } from "@/hooks/use-mobile"
import { useAuth } from "@/contexts/auth-context"
import { Leaf } from "@phosphor-icons/react"
import { adminMobileChrome } from "./admin-mobile-chrome"

interface DashboardLayoutProps {
  children: React.ReactNode
}

const creamBg = {
  backgroundColor: "var(--cream-50)",
  backgroundImage: "radial-gradient(var(--soil-200) 1.5px, transparent 1.5px)",
  backgroundSize: "20px 20px",
}

const sidebarBg = {
  backgroundColor: "var(--berry-50)",
  backgroundImage: "radial-gradient(var(--blush-300) 1.5px, transparent 1.5px)",
  backgroundSize: "20px 20px",
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const isMobile = useMobile()
  const { userType } = useAuth()
  const isUser = userType === "user"
  if (isUser) return <>{children}</>

  return (
    <div className="dashboard-shell" style={{ display: "flex", height: "100dvh", ...creamBg }}>
      {!isMobile && (
        <div className="dashboard-desktop-sidebar" style={{ width: "16rem", flexShrink: 0, ...sidebarBg, borderRight: "2px dashed var(--berry-300)" }}>
          <Sidebar />
        </div>
      )}

      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        {isMobile && !isUser && adminMobileChrome.showThemeToggle && (
          <div className="admin-mobile-theme">
            <span className="admin-mobile-brand"><Leaf size={22} aria-hidden="true" />艾艾代肝小店</span>
            <ThemeToggle />
          </div>
        )}
        {isMobile && isUser && (
          <div style={{
            padding: "12px 16px",
            textAlign: "center",
            fontSize: 16,
            fontWeight: 700,
            color: "var(--gold-600)",
            borderBottom: "1px solid var(--soil-200)",
            backgroundColor: "var(--cream-50)",
            flexShrink: 0,
          }}>
            艾艾代肝小店
          </div>
        )}

        <div
          className="dashboard-scroll"
          style={{
            flex: 1,
            padding: 24,
            overflow: "auto",
            ...(isMobile && isUser ? { paddingTop: 16, paddingBottom: "calc(100px + env(safe-area-inset-bottom))" } : {}),
            ...(isMobile && !isUser ? { paddingTop: 8, paddingBottom: "calc(100px + env(safe-area-inset-bottom))" } : {}),
          }}
        >
          <main className="dashboard-content" style={{ maxWidth: "80rem", margin: "0 auto" }}>{children}</main>
        </div>
      </div>

      {isMobile && <BottomTabBar role={isUser ? "user" : "admin"} />}
    </div>
  )
}
